import {styled, Avatar} from '@mui/material';

export const StyledAvatar = styled(Avatar)(({background}) => ({
  width: 50,
  height: 50,
  backgroundColor: background,
}));
